export default "__VITE_ASSET__BfEr9wYh__"